module.exports = __webpack_public_path__ + "img/ticket-sentosa.e3c654bc.svg";